import { memo } from 'react';

import { Button } from '@heroui/react';
import { FaExclamationTriangle, FaRedo } from 'react-icons/fa';

import core from '@/features/v2/home/components/localization/core';

import { CasinoErrorProps } from '../interface';

export const CasinoError = memo(({ error, onRetry }: CasinoErrorProps) => {
  const errorMessage = typeof error === 'string' ? error : error.message;

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-danger-900 text-danger-500">
        <FaExclamationTriangle className="h-8 w-8" />
      </div>

      <h3 className="mb-2 text-lg font-semibold text-gray-900">
        {core.public.casino.error.title}
      </h3>

      <p className="mb-6 max-w-md text-sm text-gray-600">
        {errorMessage || core.public.casino.error.description}
      </p>

      <Button
        color="primary"
        variant="solid"
        startContent={<FaRedo className="h-4 w-4" />}
        onPress={onRetry}
        className="bg-gradient-to-r from-hgradient-50 to-hgradient-100 text-white"
      >
        {core.public.casino.error.button}
      </Button>
    </div>
  );
});
